module.exports = __webpack_public_path__ + "static/media/Profile.22eed5ae.svg";